import { render, staticRenderFns } from "./IndividualPriory.vue?vue&type=template&id=d9c13e32&scoped=true&"
import script from "./IndividualPriory.vue?vue&type=script&lang=js&"
export * from "./IndividualPriory.vue?vue&type=script&lang=js&"
import style0 from "./IndividualPriory.vue?vue&type=style&index=0&id=d9c13e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c13e32",
  null
  
)

export default component.exports